import {Box} from '@mui/material';
import React from 'react';

interface WrapperProps {
  heading: React.ReactNode;
  component: React.ReactNode;
}

const Wrapper = ({heading, component}: WrapperProps) => {
  return (
    <Box
      sx={{
        backgroundColor: ' #FFFFFF',
        borderRadius: '16px',
        padding: 1,
        marginBottom: 1.25,
      }}
    >
      <Box
        sx={{
          backgroundColor: ' #F9FAFB',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '16px',
        }}
      >
        {heading}
        {component}
      </Box>
    </Box>
  );
};

export default Wrapper;
